<template>
    <div>
        <form novalidate v-on:submit.prevent>
            <div class="row">
                <nav class="p-2 bg-dark shadow w-100 position-relative">
                    <div class="form-inline">
                        <label class="sm-title my-1 mr-2 page-title">WBS Tech</label>
                        <input name="search" type="text" v-model="currentIds" placeholder="ID/IPV6"
                               class="my-1 mr-sm-2 form-control form-control-dark form-control-code ipv6Box">
                        <template v-for="(column) in columnsHidden">
                            <button class="btn badge badge-light ml-1" v-on:click="removeUiColumn(column)">{{column}} <i class="fas fa-plus-circle"></i></button>
                        </template>
                    </div>
                    <button type="button"
                            v-on:click="showControlPanel = !showControlPanel"
                            class="bar-toggle p-0 dev-tool-toggle-button"><i class="fas fa-bars"></i></button>
                </nav>
            </div>
            <div class="row" v-if="buildingPagination.show">

                <div class="deviceList" v-bind:class="{'withPanel' : showControlPanel}">
                    <div class="dropdown" v-if="currentPage == 'devices'">
                        <button type="button" class="btn btn-secondary dropdown-toggle" v-on:click="showBuildingDropdownMenu = !showBuildingDropdownMenu">
                            <span v-if="buildingId">
                                {{currentBuilding.fullAddress}} ({{currentBuilding.name}})
                            </span>
                            <span v-else-if="buildingId === 0">
                                Unknown devices
                            </span>
                            <span v-else>
                                Please Select Building
                            </span>
                        </button>
                        <div class="dropdown-menu" v-bind:class="{'show' : showBuildingDropdownMenu}">
                            <div class="container-fluid">
                                <div class="form-group hasSearch">
                                    <input type="text" class="form-control hasSearch-formControl" v-model="clientBuilding.searchText" placeholder="Search building">
                                    <i class="fa fa-search hasSearch-icon"></i>
                                </div>

                            </div>
                            <template v-for="building in pagedBuilding">
                                <a href="javascript:void(0)"
                                   class="dropdown-item"
                                   v-on:click="buildingId = building.id; showBuildingDropdownMenu = false; fetchAllDevices()">
                                    {{building.fullAddress}} ({{building.name}})
                                </a>
                            </template>
                            <hr>
                            <a href="javascript:void(0)"
                               class="dropdown-item"
                               v-on:click="buildingId = 0; showBuildingDropdownMenu = false; fetchAllDevices()">
                                Unknown devices
                            </a>

                            <div class="paginationSection" v-if="clientBuilding.totalPage > 1">
                                <paginate
                                        v-model="clientBuilding.currentPage"
                                        :page-count="clientBuilding.totalPage"
                                        :prev-text="'Prev'"
                                        :next-text="'Next'"
                                        :container-class="'pagination justify-content-center'"
                                        :page-class="'page-item'"
                                        :prev-link-class="'page-link'"
                                        :next-link-class="'page-link'"
                                        :page-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                    <div class="table-wrapper-scroll-y">
                        <div class="table">
                            <table class="table table-striped table-bordered dev-dashboard-table">
                                <thead class="thead-dark text-nowrap">
                                <tr v-if="initLoaded && currentPage == 'gateways'" class="bg-light">
                                    <td></td>
                                    <td v-bind:class="[columnsHidden.indexOf('id') > -1?'d-none':'']"></td>

                                    <td v-bind:class="[columnsHidden.indexOf('EM') > -1?'d-none':'']"></td>

                                    <td v-bind:class="[columnsHidden.indexOf('IPV6') > -1?'d-none':'']">
                                        <strong>Unknown Devices</strong>
                                        <ToolTip>
                                            <span class="badge superScript">
                                                <i class="fas fa-info-circle"
                                                   data-toggle="tooltip"
                                                   data-placement="top"
                                                   data-html="true"
                                                   title=""
                                                   data-original-title="Devices connect to gateway, however, don't belong to a building"
                                                ></i>
                                            </span>
                                        </ToolTip>
                                    </td>
                                    <td v-bind:class="[columnsHidden.indexOf('SIM') > -1?'d-none':'']" v-if="currentPage == 'gateways'"></td>

                                    <td v-bind:class="[columnsHidden.indexOf('Address') > -1?'d-none':'']" v-if="currentPage == 'gateways'"></td>

                                    <td v-bind:class="[columnsHidden.indexOf('Model') > -1?'d-none':'']"></td>
                                    <td v-bind:class="[columnsHidden.indexOf('GW') > -1?'d-none':'']" v-if="currentPage == 'devices'"></td>
                                    <td v-bind:class="[columnsHidden.indexOf('Lv') > -1?'d-none':'']"></td>
                                    <td v-bind:class="[columnsHidden.indexOf('Location') > -1?'d-none':'']"></td>

                                    <td v-bind:class="[columnsHidden.indexOf('FW') > -1?'d-none':'']"></td>

                                    <td v-bind:class="[columnsHidden.indexOf('BLE') > -1?'d-none':'']"></td>

                                    <td v-bind:class="[columnsHidden.indexOf('PV') > -1?'d-none':'']" v-if="currentPage == 'gateways'"></td>

                                    <td v-bind:class="[columnsHidden.indexOf('Device FW') > -1?'d-none':'', unknownDeviceSummary.device_fw === unknownDeviceSummary.total? 'bg-success-lighter' : 'bg-danger-lighter']" v-if="currentPage == 'gateways'">
                                        <template v-for="(generation, j) in generationConfig[0]">
                                            <template v-if="generation !== 'unknown' || (unknownDeviceSummary.summaries[generation] && unknownDeviceSummary.summaries[generation].total)">
                                                <div class="text-nowrap badge badge-light mr-1">
                                                    <template v-if="unknownDeviceSummary.summaries[generation]">
                                                        <i class="fas fa-check-circle text-success" v-if="unknownDeviceSummary.summaries[generation].latest_firmware === unknownDeviceSummary.summaries[generation].total"></i>
                                                        <i class="fas fa-times-circle text-danger" v-else></i>
                                                        {{unknownDeviceSummary.summaries[generation].latest_firmware}}/{{unknownDeviceSummary.summaries[generation].total}} ({{generation === 'unknown' ? 'no model info' : `GEN ${generation}`}})
                                                    </template>
                                                    <template v-else>
                                                        <i class="fas fa-exclamation-circle text-success"></i>
                                                        0/0 (GEN {{generation}})
                                                    </template>
                                                </div><br>
                                            </template>
                                        </template>
                                    </td>

                                    <td v-bind:class="[columnsHidden.indexOf('Network') > -1?'d-none':'', unknownDeviceSummary.network === unknownDeviceSummary.total? 'bg-success-lighter' : 'bg-danger-lighter']" v-if="currentPage == 'gateways'">
                                        <span class="text-nowrap badge badge-light">
                                            <i class="fas fa-times-circle text-success" v-if="unknownDeviceSummary.network === unknownDeviceSummary.total"></i>
                                            <i class="fas fa-times-circle text-danger" v-else></i>
                                            {{unknownDeviceSummary.network}}/{{unknownDeviceSummary.total}}
                                        </span>
                                    </td>

                                    <td v-bind:class="[columnsHidden.indexOf('Commission') > -1?'d-none':'', !unknownDeviceSummary.total ? 'bg-success-lighter' : 'bg-danger-lighter']" v-if="currentPage == 'gateways'">
                                        <span class="text-nowrap badge badge-light">
                                            <i class="fas fa-exclamation-circle text-success" v-if="!unknownDeviceSummary.total"></i>
                                            <i class="fas fa-times-circle text-danger" v-else></i>
                                            {{unknownDeviceSummary.total}}
                                        </span>
                                        <ToolTip>
                                            <span class="badge superScript">
                                                <i class="fas fa-info-circle"
                                                   data-toggle="tooltip"
                                                   data-placement="top"
                                                   data-html="true"
                                                   title=""
                                                   data-original-title="Total not commissioned devices"
                                                ></i>
                                            </span>
                                        </ToolTip>
                                    </td>

                                    <td v-bind:class="[columnsHidden.indexOf('Last Comm') > -1?'d-none':'']"></td>
                                    <td v-bind:class="[columnsHidden.indexOf('Smart Building Status') > -1?'d-none':'']" v-if="currentPage == 'gateways'"></td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th v-bind:class="[columnsHidden.indexOf('id') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('id')">id <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('id')"></i>
                                        </div>
                                    </th>
                                    <th v-bind:class="[columnsHidden.indexOf('EM') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('fitting_number')">EM <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('EM')"></i>
                                        </div>
                                    </th>
                                    <th v-bind:class="[columnsHidden.indexOf('IPV6') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('ip_addr')">IPV6 <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('IPV6')"></i>
                                        </div>
                                    </th>
                                    <th v-if="currentPage == 'gateways'" v-bind:class="[columnsHidden.indexOf('SIM') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('sim')">SIM <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('SIM')"></i>
                                        </div>
                                    </th>
                                    <th v-if="currentPage == 'gateways'" v-bind:class="[columnsHidden.indexOf('Address') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('address')">Address <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Address')"></i>
                                        </div>
                                    </th>
                                    <th v-bind:class="[columnsHidden.indexOf('Model') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('device_model.name')">Model <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Model')"></i>
                                        </div>
                                    </th>
                                    <th v-if="currentPage == 'devices'" v-bind:class="[columnsHidden.indexOf('GW') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('gateway_id')">GW <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('GW')"></i>
                                        </div>
                                    </th>
                                    <th v-bind:class="[columnsHidden.indexOf('Lv') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('level')">Lv <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Lv')"></i>
                                        </div>
                                    </th>
                                    <th v-bind:class="[columnsHidden.indexOf('Location') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('location')">Location <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Location')"></i>
                                        </div>
                                    </th>
                                    <th v-bind:class="[columnsHidden.indexOf('FW') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('firmware_no')">FW <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('FW')"></i>
                                        </div>
                                    </th>
                                    <th v-bind:class="[columnsHidden.indexOf('BLE') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('ble_version')">BLE <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('BLE')"></i>
                                        </div>
                                    </th>
                                    <th v-if="currentPage == 'gateways'" v-bind:class="[columnsHidden.indexOf('PV') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('python_ver')">PV <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('PV')"></i>
                                        </div>
                                    </th>
                                    <th v-if="currentPage == 'gateways'" v-bind:class="[columnsHidden.indexOf('Device FW') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('device_summary.device_fw')">Device FW <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Device FW')"></i>
                                        </div>
                                    </th>
                                    <th v-if="currentPage == 'gateways'" v-bind:class="[columnsHidden.indexOf('Network') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('device_summary.network')">Network <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Network')"></i>
                                        </div>
                                    </th>
                                    <th v-if="currentPage == 'gateways'" v-bind:class="[columnsHidden.indexOf('Commission') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('device_summary.commission')">Commission <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Commission')"></i>
                                        </div>
                                    </th>
                                    <th v-bind:class="[columnsHidden.indexOf('Last Comm') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('last_comm')">Last Comm <i class="fas fa-sort"></i></div>
                                            <span><input type="checkbox" v-model="currentSort.readable"/></span>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Last Comm')"></i>
                                        </div>
                                    </th>
                                    <th v-if="currentPage == 'gateways'" v-bind:class="[columnsHidden.indexOf('Smart Building Status') > -1?'d-none':'']">
                                        <div class="d-flex justify-content-between">
                                            <div @click="sort('smart_building')">Smart Building Status <i class="fas fa-sort"></i></div>
                                            <i class="fas fa-minus-circle ml-1 icon" v-on:click="addUiColumn('Smart Building Status')"></i>
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>

                                <tr v-if="initLoaded" v-for="(device,index) in sortedDevices"
                                    @click="ahcher(device.id)"
                                    v-bind:data-id="device.id"
                                    ref="devices"
                                    v-bind:class="{'bg-info': deviceId.indexOf(device.id) > -1 || deviceId == device.id}">
                                    <td><input type="checkbox" :value="device.id" v-model="deviceId"></td>
                                    <td v-bind:class="[columnsHidden.indexOf('id') > -1?'d-none':'']">{{device.id}}</td>

                                    <td v-bind:class="[columnsHidden.indexOf('EM') > -1?'d-none':'']" v-if="device.fitting_number">{{device.fitting_number}}</td>
                                    <td v-bind:class="[columnsHidden.indexOf('EM') > -1?'d-none':'']" class="bg-danger-lighter" v-else></td>

                                    <td v-bind:class="[columnsHidden.indexOf('IPV6') > -1?'d-none':'']" v-if="device.ip_addr">{{device.ip_addr}}</td>
                                    <td v-bind:class="[columnsHidden.indexOf('IPV6') > -1?'d-none':'']" v-else></td>
                                    <td v-bind:class="[columnsHidden.indexOf('SIM') > -1?'d-none':'']" v-if="currentPage == 'gateways'"><span class="text-small text-nowrap" v-if="device.sim">{{device.sim}}</span><span v-else>N/A</span></td>

                                    <td v-bind:class="[columnsHidden.indexOf('Address') > -1?'d-none':'', currentPage == 'gateways' && device.fullAddress ? '' : 'bg-danger-lighter']" v-if="currentPage == 'gateways'">
                                        <span class="text-small" v-if="device.building_id && device.fullAddress && sortedBuildings.length">{{device.fullAddress}}</span>
                                        <span class="badge badge-light" v-else>
                                            <i class="fas fa-times-circle text-danger"></i> N/A
                                            <ToolTip>
                                                <span class="badge" v-bind:class="[device.building_id?'superScript':'text-warning']">
                                                    <i class="fas fa-info-circle"
                                                       data-toggle="tooltip"
                                                       data-placement="top"
                                                       data-html="true"
                                                       title=""
                                                       v-bind:data-original-title="device.building_id?'Address is empty':'Does not attach to a building'"
                                                    ></i>
                                                </span>
                                            </ToolTip>
                                        </span>
                                    </td>

                                    <td v-bind:class="[columnsHidden.indexOf('Model') > -1?'d-none':'']" v-if="device.device_model"><span class="text-small text-nowrap">{{device.device_model.name}}</span></td>
                                    <td v-bind:class="[columnsHidden.indexOf('Model') > -1?'d-none':'']" v-else></td>
                                    <td v-bind:class="[columnsHidden.indexOf('GW') > -1?'d-none':'']" v-if="currentPage == 'devices'">
                                        <span v-if="device.gateway_id">{{device.gateway_id}}</span>
                                    </td>
                                    <td v-bind:class="[columnsHidden.indexOf('Lv') > -1?'d-none':'']" v-if="device.level">{{device.level}}</td>
                                    <td v-bind:class="[columnsHidden.indexOf('Lv') > -1?'d-none':'']" v-else></td>
                                    <td v-bind:class="[columnsHidden.indexOf('Location') > -1?'d-none':'']" v-if="device.location"><span class="text-small">{{device.location}}</span></td>
                                    <td v-bind:class="[columnsHidden.indexOf('Location') > -1?'d-none':'']" v-else></td>

                                    <td v-if="device.firmware_no" v-bind:class="[columnsHidden.indexOf('FW') > -1?'d-none':'', deviceModels[device.device_model_id] && firmwares[device.type === 'gateway'?1:0] && firmwares[device.type === 'gateway'?1:0]['firmware'][deviceModels[device.device_model_id]['generation']] <= device.firmware_no_int ? 'bg-success-lighter' : 'bg-danger-lighter']">
                                        <span class="text-nowrap badge badge-light" v-if="deviceModels[device.device_model_id]">
                                            <i class="fas fa-check-circle text-success" v-if="firmwares[device.type === 'gateway'?1:0]['firmware'][deviceModels[device.device_model_id]['generation']] <= device.firmware_no_int"></i>
                                            <i class="fas fa-times-circle text-danger" v-else></i>
                                            {{device.firmware_no}} (GEN {{deviceModels[device.device_model_id]['generation']}})
                                        </span>
                                        <span class="text-nowrap badge badge-light" v-else>
                                            <i class="fas fa-times-circle text-danger"></i> N/A
                                            <ToolTip>
                                                <span class="badge superScript">
                                                    <i class="fas fa-info-circle"
                                                       data-toggle="tooltip"
                                                       data-placement="top"
                                                       data-html="true"
                                                       title=""
                                                       data-original-title="Device model does not found"
                                                    ></i>
                                                </span>
                                            </ToolTip>
                                        </span>
                                    </td>
                                    <td v-bind:class="[columnsHidden.indexOf('FW') > -1?'d-none':'']" class="bg-danger-lighter" v-else></td>

                                    <td v-bind:class="[columnsHidden.indexOf('BLE') > -1?'d-none':'']" v-if="device.ble_version"><span class="text-nowrap">{{device.ble_version}}</span></td>
                                    <td v-bind:class="[columnsHidden.indexOf('BLE') > -1?'d-none':'']" v-else></td>

                                    <td v-bind:class="[columnsHidden.indexOf('PV') > -1?'d-none':'', device.python_ver && firmwares[device.type === 'gateway'?1:0] && firmwares[device.type === 'gateway'?1:0]['file_system']['n/a'] <= device.python_ver_int ? 'bg-success-lighter' : 'bg-danger-lighter']" v-if="currentPage == 'gateways'">
                                        <span class="text-nowrap badge badge-light" v-if="device.python_ver">
                                            <i class="fas fa-check-circle text-success" v-if="firmwares[device.type === 'gateway'?1:0]['file_system']['n/a'] <= device.python_ver_int"></i>
                                            <i class="fas fa-times-circle text-danger" v-else></i>
                                            {{device.python_ver}}
                                        </span>
                                    </td>

                                    <td v-bind:class="[columnsHidden.indexOf('Device FW') > -1?'d-none':'', !device.devices_summary.total || device.devices_summary.device_fw === device.devices_summary.total? 'bg-success-lighter' : 'bg-danger-lighter']" v-if="currentPage == 'gateways'">
                                        <template v-for="(generation, j) in generationConfig[0]">
                                            <template v-if="generation !== 'unknown' || (device.devices_summary.summaries[generation] && device.devices_summary.summaries[generation].total)">
                                            <div class="text-nowrap badge badge-light mr-1">
                                                <template v-if="device.devices_summary.summaries[generation]">
                                                    <i class="fas fa-check-circle text-success" v-if="device.devices_summary.summaries[generation].latest_firmware === device.devices_summary.summaries[generation].total"></i>
                                                    <i class="fas fa-times-circle text-danger" v-else></i>
                                                    {{device.devices_summary.summaries[generation].latest_firmware}}/{{device.devices_summary.summaries[generation].total}} ({{generation === 'unknown' ? 'no model info' : `GEN ${generation}`}})
                                                </template>
                                                <template v-else>
                                                    <i class="fas fa-exclamation-circle text-primary"></i>
                                                    0/0 (GEN {{generation}})
                                                </template>
                                            </div><br>
                                            </template>
                                        </template>
                                    </td>

                                    <td v-bind:class="[columnsHidden.indexOf('Network') > -1?'d-none':'', !device.devices_summary.total || device.devices_summary.network === device.devices_summary.total? 'bg-success-lighter' : 'bg-danger-lighter']" v-if="currentPage == 'gateways'">
                                        <span class="text-nowrap badge badge-light">
                                            <i class="fas fa-exclamation-circle text-primary" v-if="!device.devices_summary.total"></i>
                                            <i class="fas fa-times-circle text-success" v-else-if="device.devices_summary.network === device.devices_summary.total"></i>
                                            <i class="fas fa-times-circle text-danger" v-else></i>
                                            {{device.devices_summary.network}}/{{device.devices_summary.total}}
                                        </span>
                                    </td>

                                    <td v-bind:class="[columnsHidden.indexOf('Commission') > -1?'d-none':'', !device.devices_summary.total || device.devices_summary.commission === device.devices_summary.total? 'bg-success-lighter' : 'bg-danger-lighter']" v-if="currentPage == 'gateways'">
                                        <span class="text-nowrap badge badge-light">
                                            <i class="fas fa-exclamation-circle text-primary" v-if="!device.devices_summary.total"></i>
                                            <i class="fas fa-check-circle text-success" v-else-if="device.devices_summary.commission === device.devices_summary.total"></i>
                                            <i class="fas fa-times-circle text-danger" v-else></i>
                                            {{device.devices_summary.commission}}/{{device.devices_summary.total}}
                                        </span>
                                    </td>

                                    <td v-bind:class="[columnsHidden.indexOf('Last Comm') > -1?'d-none':'', (new Date()).getTime() - device.last_comm * 1000 < 108000000 ? 'bg-success-lighter' : 'bg-danger-lighter']" v-if="device.last_comm">
                                        <span class="badge badge-light">
                                            <i class="fas fa-check-circle text-success" v-if="(new Date()).getTime() - device.last_comm * 1000 < 108000000"></i>
                                            <i class="fas fa-times-circle text-danger" v-else></i>
                                            {{device.status?device.status:''}}
                                        </span><br v-if="currentPage == 'gateways'"/><span class="mr-1" v-else></span>
                                        <span class="badge badge-light">
                                        {{
                                        currentSort.readable ?
                                        tools.humanizedTimeSpan(new Date(device.last_comm * 1000), new Date()) :
                                        new Date(device.last_comm * 1000)
                                            .toLocaleDateString(
                                                'en-AU',
                                                {
                                                    year: '2-digit',
                                                    month: '2-digit',
                                                    day: '2-digit',
                                                    hour: '2-digit',
                                                    hour12: false,
                                                    minute: '2-digit',
                                                    second: '2-digit'
                                                }
                                            )
                                        }}
                                        </span>
                                    </td>
                                    <td v-bind:class="[columnsHidden.indexOf('Last Comm') > -1?'d-none':'']" v-else></td>
                                    <td v-bind:class="[columnsHidden.indexOf('Smart Building Status') > -1?'d-none':'']" v-if="currentPage == 'gateways'">
                                        <span v-if="!device.smart_building || device.smart_building == 'DISABLED' " class="text-nowrap">OFF</span>
                                        <span v-else>ON</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div id="controlPanel" v-bind:class="{'d-none': !showControlPanel}">
                    <div class="control-panel-inner">

                        <div class="form-group">
                            <button type="button" class="btn btn-block btn-primary btn-sm" @click="unSelect()">UN-SELECT</button>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-block btn-primary btn-sm" v-if="currentPage == 'devices'" @click="fetchAllDevices()">
                                RELOAD
                            </button>
                            <button type="button" class="btn btn-block btn-primary btn-sm" v-if="currentPage == 'gateways'" @click="getGateways()">
                                RELOAD
                            </button>
                        </div>

                        <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-primary btn-sm" @click="retrieveLog('full-logs-splunk')">
                                    FULL LOG
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-primary btn-sm" @click="retrieveLog('event-logs-splunk')">
                                    EVENT LOG
                                </button>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-primary btn-sm" v-if="currentPage == 'devices'" @click="locateDevice()">
                                    FIND
                                </button>
                                <button type="button" class="btn btn-block btn-primary btn-sm" v-if="currentPage == 'gateways'" @click="locateGateway()">
                                    FIND
                                </button>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-primary btn-sm" @click="sendTechnicianAccessibleCommands('PING')">
                                    PING
                                </button>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-primary btn-sm" @click="sendTechnicianAccessibleCommands('STATUS')">
                                    STATUS
                                </button>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-primary btn-sm" @click="sendCommand('BR_REG_REQ')" title="border router register request">
                                    BR REG REQ
                                </button>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-secondary btn-sm" @click="sendTechnicianAccessibleCommands('TEST')">
                                    TEST
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-secondary btn-sm" @click="sendTechnicianAccessibleCommands('TEST_ABORT')">
                                    CANCEL TEST
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-secondary btn-sm" @click="sendTechnicianAccessibleCommands('FUNC_TEST')">
                                    Func TEST
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-danger btn-sm" @click="confirmPopup('PINGALL')">
                                    PING ALL
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-danger btn-sm" @click="confirmPopup('TESTALL')">
                                    TEST ALL
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-danger btn-sm" @click="confirmPopup('RESET')">
                                    RESET
                                </button>
                            </div>
                            <div class="form-group" v-if="currentPage == 'gateways'">
                                <button class="btn btn-block btn-danger btn-sm" @click="confirmPopup('START_OTA')">
                                    START OTA
                                </button>
                            </div>
                            <div class="form-group" v-if="currentPage == 'gateways'">
                                <button type="button" class="btn btn-block btn-danger btn-sm" @click="confirmPopup('START_OTA_SECOND_GEN')">
                                    START 2ND GEN OTA
                                </button>
                            </div>

                            <div class="form-group" v-if="currentPage == 'gateways'">
                                <button type="button" class="btn btn-block btn-danger btn-sm" @click="confirmPopup('GW_OTA')">
                                    Gateway OTA
                                </button>
                            </div>
                            <div class="form-group" v-if="currentPage == 'gateways'">
                                <button type="button" class="btn btn-block btn-danger btn-sm" @click="confirmPopup('STOP_OTA')">
                                    STOP OTA
                                </button>
                            </div>
                            <div class="form-group" v-if="currentPage == 'gateways'">
                                <button type="button" class="btn btn-block btn-danger btn-sm" @click="confirmPopup('MANUAL_OTA')">
                                    Manual OTA
                                </button>
                            </div>
                            <div v-if="currentPage == 'gateways'" class="form-group">
                                <button type="button" class="btn btn-block btn-danger btn-sm" @click="confirmPopup('RESET_GW')" title="restart gateway">
                                    RESET GW
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-danger btn-sm text-nowrap" @click="manualCommand()">
                                    Manual Command
                                </button>
                            </div>
                            <div class="form-group" v-if="currentPage == 'gateways'">
                                <button type="button" class="btn btn-block btn-warning btn-sm" @click="confirmPopup('ENABLE_SMART_BUILDING')">
                                    ENABLE SMART BUILDING
                                </button>
                            </div>
                            <div class="form-group" v-if="currentPage == 'gateways'">
                                <button type="button" class="btn btn-block btn-warning btn-sm" @click="confirmPopup('DISABLE_SMART_BUILDING')">
                                    DISABLE SMART BUILDING
                                </button>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-primary btn-sm" @click="retrieveLog('logs')">
                                    FULL LOG (LEGACY)
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block btn-primary btn-sm" @click="retrieveLog('event-logs')">
                                    EVENT LOG (LEGACY)
                                </button>
                            </div>

                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="no-popup" value="1" class="custom-control-input"
                                       v-model="noPopup">
                                <label for="no-popup" class="custom-control-label">No Popup</label>
                                <small class="d-block text-muted">log in Browser console</small>
                            </div>
                        </RequiresGlobalPermissions>
                    </div>
                </div>
            </div>
        </form>
        <DashBoardModalComponent v-if="dataToPassToDashBoardModal.showModal"
                                 @close="dataToPassToDashBoardModal.showModal = false"
                                 :confirm="confirm"
                                 :dataToPassToModal="dataToPassToDashBoardModal"></DashBoardModalComponent>

        <DevicesStatusModalComponent v-if="dataToPassToDeviceStatusModal.showModal"
                                     @close="dataToPassToDeviceStatusModal.showModal = false"
                                     :confirm="confirm"
                                     :dataToPassToModal="dataToPassToDeviceStatusModal"
                                     :dataObject="devices"></DevicesStatusModalComponent>

        <DevicesLogModalComponent ref="devicesLogModal" v-if="dataToPassToDeviceLogModal.showModal"
                                  @close="dataToPassToDeviceLogModal.showModal = false"
                                  :confirm="confirm"
                                  :dataToPassToModal="dataToPassToDeviceLogModal"
                                  :dataObject="devices"
        ></DevicesLogModalComponent>
        <ManualCommandModalComponent v-if="dataToPassToManualCommandModal.showModal"
                                     @close="dataToPassToManualCommandModal.showModal = false"
                                     :dataToPassToModal="dataToPassToManualCommandModal">
        </ManualCommandModalComponent>
    </div>
</template>
<style lang="scss" scoped>
    @import "@/../sass/_mixins.scss";

    .bg-danger-lighter {
        background-color: lighten($danger, 40%);
    }

    .bg-success-lighter {
        background-color: lighten($success, 40%);
    }

    .text-small {
        font-size: 14px;
    }
    .deviceList {
        width: 100%;
        &.withPanel {
            width: calc(100% - 165px);
        }
        .dropdown {
            margin: 15px 0;
            .dropdown-toggle {
                display: block;
                width: 100%;
                text-align: left;
            }
            .dropdown-menu {
                &.show {
                    width: 100%;
                }
                @include building-search;
            }
        }
    }
    .shadow {
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
    }

    .table-wrapper-scroll-y {
        display: block;
        height: calc(100vh - 270px);
        overflow: scroll;
        background: #fff;
    }

    .page-title {
        color: #fff;
    }

    .dev-tool-toggle-button {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        font-size: 30px;
        color: #fff;
        background: transparent;
        height: 40px;
        border-style: none;
        outline: 0;
    }

    .control-panel-inner {
        position: fixed;
        right: 0;
        display: block;
        height: calc(100vh - 213px);
        width: 150px;
        margin-right: 15px;
        padding: 10px;
        background: white;
        overflow-x: scroll;
    }

    .ipv6Box {
        display: inline;
        width: 220px;
    }

    thead th span {
        margin-right: 20px;
    }

    .dev-dashboard-table {
        thead th {
            cursor: pointer;
            position: sticky;
            position: -webkit-sticky;
            top: 0px;
            .icon {
                line-height: 1.5;
            }
        }
        tr.bg-info {
            background-color: $info !important;
            td {
                &.bg-danger-lighter,
                &.bg-success-lighter {
                    background-color: $info !important;
                }
            }
        }
    }
</style>
<script>
import Vue from 'vue';
import Tools from '@/app-model/tools.js';
import ToolTip from '@/components/tool-tip/ToolTip.vue'
import Building from '@/app-model/building.js';
import DeviceModel from '@/app-model/deviceModel.js';
import DashBoardModalComponent from '../../../components/modal/DashBoardModalComponent.vue'
import DevicesStatusModalComponent from '../../../components/modal/DevicesStatusModalComponent.vue'
import DevicesLogModalComponent from '../../../components/modal/DevicesLogModalComponent.vue'
import axios from 'axios'
import ConfirmActionModalComponent from '../../../components/modal/ConfirmActionModalComponent.vue'
import ManualCommandModalComponent from '../../../components/modal/ManualCommandModalComponent.vue'
import RequiresGlobalPermissions from "@/components/RequiresGlobalPermissions";

export default {
    components: {
      RequiresGlobalPermissions,
      DashBoardModalComponent,
      DevicesStatusModalComponent,
      DevicesLogModalComponent,
      ConfirmActionModalComponent,
      ManualCommandModalComponent,
      ToolTip
    },
    data () {
      return {
        initLoaded: false,
        reload: false,
        columnsHidden: [],
        showBuildingDropdownMenu: false,
        showControlPanel: true,
        currentPage: '',
        promises: [],
        deviceId: [],
        currentIds: '',
        index: '',
        statusCode: '',
        noPopup: [],
        clientBuilding: {
          searchText: '',
          totalPage: 0,
          currentPage: 1,
          perPage: 50,
        },
        buildingPagination: {
          currentPage: 1,
          totalPage: 0,
          show: false,
        },
        currentSort: {
          field: 'last_comm',
          sort: 'desc',
          readable: true,
        },
        buildings: [],
        showTotalResults: 5,
        buildingId: undefined,
        deviceModels: {},
        generationConfig: {},
        firmwareCategory: {},
        firmwares: {},
        devices: [],
        gatewayDeviceSummary: {},
        unknownDeviceSummary: {
          device_fw: 0,
          network: 0,
          total: 0,
          summaries: {}
        },
        dataToPassToModal: {
          showModal: false,
        },
        dataToPassToDashBoardModal: {
          showModal: false,
          deviceIds: [],
        },
        dataToPassToDeviceStatusModal: {
          showModal: false,
          modalData: []
        },
        dataToPassToDeviceLogModal: {
          showModal: false,
          deviceId: 0,
          deviceIp: '',
          command: ''
        },
        dataToPassToManualCommandModal: {
          showModal: false,
          deviceId: '',
          ip_address: ''

        },
        confirm: {
          action: '',
          title: '',
          msg: ''
        },
      }
    },
    async created () {
      let top = this;
      this.initLoaded = false;
      this.currentPage = this.$route.name;
      switch (this.currentPage) {
        case 'devices':
          await this.getDeviceModel();
          await this.getBuildings().then(() => {
            this.initLoaded = true;
          });
          break;
        case 'gateways':
          await this.getDeviceModel();
          await this.getBuildings();
          await this.getGateways().then(() => {
            this.initLoaded = true;
          });
          break;
      }
      let uiData = localStorage.getItem(`ui-${this.currentPage}`);
      this.columnsHidden = uiData ? JSON.parse(uiData) : [];
    },
    methods: {
      removeUiColumn: function(column) {
        this.columnsHidden = this.columnsHidden.filter(e => e !== column);
        localStorage.setItem(`ui-${this.currentPage}`, JSON.stringify(this.columnsHidden));
      },
      addUiColumn: function(column) {
        this.columnsHidden.push(column);
        localStorage.setItem(`ui-${this.currentPage}`, JSON.stringify(this.columnsHidden));
      },
      findBuildingProperty: function(building_id, property) {
        let building = this.sortedBuildings.find(el => {
          return el.id === building_id;
        });
        return building?.[property];
      },
      async getBuildings () {
        this.buildings = [];
        this.buildingPagination.currentPage = 0;
        this.buildingPagination.totalPage = 0;
        this.buildingPagination.show = false;

        let response = await this.fetchPagedBuildings(0);
        switch (response.status) {
          case 200 :
            for(let i = 1; i < response.data.meta.last_page; i++) {
              this.fetchPagedBuildings(i);
            }
            break;
        }
      },
      fetchPagedBuildings (page) {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/buildings?page=${page + 1}&per_page=200`,
          path_template: '/api/buildings'
        }).then(response => {
          switch (response.status) {
            case 200 :
              Object.assign(this.buildings, this.buildings.concat(response.data.data));
              this.buildingPagination.currentPage ++;
              if(!this.buildingPagination.totalPage) {
                this.buildingPagination.totalPage = response.data.meta.last_page;
              }
              this.buildingPagination.show = this.buildingPagination.currentPage === this.buildingPagination.totalPage;
              break;
          }

          return response;
        });
      },
      getGateways: function () {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/gateways`,
          path_template: '/api/gateways'
        }).then(response => {
          this.devices = response.data.data;
          for( let i in this.devices) {
            let device = this.devices[i];
            let sim, firmware_no_int, python_ver_int;

            if(device.sim !== undefined && device.sim !== null) {
              let {sim : {gw_ccid = '', rssi = ''} = {}} = device;
              sim = `${gw_ccid}-${rssi}`.replace(/\-$/, '').replace(/^\-/, '');
              firmware_no_int = device.firmware_no ? parseInt(device.firmware_no.substr(2), 16) : undefined;
              python_ver_int = device.python_ver ? parseInt(device.python_ver.substr(2), 16) : undefined;
            }
            this.devices[i] = Object.assign(
              device,
              {
                device_model: this.deviceModels[device.device_model_id],
                sim,
                firmware_no_int,
                python_ver_int,
                devices_summary: {
                  device_fw: 0,
                  network: 0,
                  commission: 0,
                  summaries: []
                },
                fullAddress: device.building_id ? this.findBuildingProperty(device.building_id, 'fullAddress') : undefined
              }
            );
          }

          return response;
        }).then(response => {
          return this.getGatewayDeviceSummary();
        });
      },
      getGatewayDeviceSummary: function () {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/gateway-device-summary`,
          path_template: '/api/gateway-device-summary'
        }).then(response => {
          let result = {}, unknownDeviceSummary = {};
          this.unknownDeviceSummary = {
            device_fw: 0,
            network: 0,
            total: 0,
            summaries: {}
          };
          for (let i = 0; i < response.data.data.length; i++) {
            let row = response.data.data[i];
            if(result[row.id] === undefined) {
              result[row.id] = {};
            }
            row.generation = row.generation === null ? 'unknown' : row.generation;
            result[row.id][row.generation] = row;
          }

          for (let i = 0; i < this.generationConfig[0].length; i++) {
            let generation = this.generationConfig[0][i];
            unknownDeviceSummary[generation] = {
              'total': 0,
              'generation': generation,
              'latest_firmware': 0,
              'network': 0,
            }
          }
          Vue.set(this.unknownDeviceSummary, 'summaries', unknownDeviceSummary);

          for(let i = 0; i < this.devices.length; i++) {
            let device = this.devices[i], summaries = result?.[device.id];
            summaries = summaries ? summaries : {};
            this.devices[i]['devices_summary']['device_fw'] = 0;
            this.devices[i]['devices_summary']['network'] = 0;
            this.devices[i]['devices_summary']['commission'] =0;
            this.devices[i]['devices_summary']['total'] = 0;
            this.devices[i]['devices_summary']['summaries'] = summaries ? summaries : {};

            for (const summary of Object.values(this.devices[i]['devices_summary']['summaries'])) {
              this.devices[i]['devices_summary']['device_fw'] += summary.latest_firmware;
              this.devices[i]['devices_summary']['network'] += summary.network;
              this.devices[i]['devices_summary']['commission'] += summary.commission;
              this.devices[i]['devices_summary']['total'] += summary.total;

              this.unknownDeviceSummary['device_fw'] += summary.unknown_devices_latest_firmware;
              this.unknownDeviceSummary['network'] += summary.unknown_devices_network;
              this.unknownDeviceSummary['total'] += summary.total - summary.commission;
              this.unknownDeviceSummary['summaries'][summary.generation]['total'] += summary.total - summary.commission;
              this.unknownDeviceSummary['summaries'][summary.generation]['latest_firmware'] += summary.unknown_devices_latest_firmware;
              this.unknownDeviceSummary['summaries'][summary.generation]['network'] += summary.unknown_devices_network;
            }
          }

          this.reload = !this.reload;
          return response;
        })
      },
      getDeviceModel () {
        this.deviceModelTools.all({store: this.$store}).then(({response, result}) => {
          let {device_models, firmware_key, generations, firmware_category} = result;
          if (firmware_key) {
            generations[0].push('unknown');
            Vue.set(this, 'generationConfig', Object.assign({}, generations));
            Vue.set(this, 'firmwareCategory', Object.assign({}, firmware_category));

            for (let i = 0; i < device_models.length; i++) {
              Vue.set(this.deviceModels, device_models[i]['id'], Object.assign({}, device_models[i]));
            }

            return this.deviceModelTools.getDefaultFirmware(
              {store: this.$store},
              firmware_key,
              generations,
              firmware_category
            ).then(({response, result}) => {
              let {firmwaresInDecimal: firmwares} = result;
              if (firmwares) {
                Vue.set(this, 'firmwares', firmwares);
              }
              return {response, result: Object.assign({}, result, {firmwares})};
            });
          }
          return {response, result};
        })
      },
      currentArrIds: function () {
        let response, macOrIp
        return this
          .currentIds
          .split(',')
          .filter(function (el) {
            return el != null
          })
          .map(async el => {
            if (parseInt(el).toString() !== el.toString()) {
              el = el.trim()
              macOrIp = el.split(':').join('')
              if (macOrIp.length <= 12) {
                response = await this.$store.dispatch('apiResult', {
                  method: 'GET',
                  path: 'api/devices?mac_addr=' + el,
                  path_template: '/api/devices'
                })
              }
              else {
                response = await this.$store.dispatch('apiResult', {
                  method: 'GET',
                  path: 'api/devices?ip_addr=' + el,
                  path_template: '/api/devices'
                })
              }

              switch (response.status) {
                case 200:
                  el = response.data.data[0].id
                  break
              }
            }
            return el
          })
      },
      resolveIp: async function(deviceId) {
        const response = await this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/devices/${deviceId}`,
          path_template: '/api/devices'
        });

        return response.data.data.ip_addr;
      },
      ahcher: function (currentDeviceId) {
        currentDeviceId = parseInt(currentDeviceId) * 1
        if (this.deviceId.indexOf(currentDeviceId) > -1) {
          this.deviceId.splice(this.deviceId.indexOf(currentDeviceId), 1)
        } else {
          this.deviceId.push(currentDeviceId)
        }
        this.deviceId.sort((a, b) => a - b)
        this.currentIds = this.deviceId.join(',')
      },
      locateDevice: async function () {
        let currentArrIds = this.currentArrIds()

        if (currentArrIds.length !== 1) {
          alert('Please select one device')
          return
        }

        let deviceId = await currentArrIds[0]

        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/devices/${deviceId}`,
          path_template: '/api/devices/{id}'
        }).then(response => {
          switch (response.status) {
            case 200 :
              let device = response.data.data
              this.buildingId = device.building_id
              this.fetchAllDevices()
                .then(response => {
                  let index = this.$refs.devices.findIndex(el => el.getAttribute('data-id') === device.id.toString());
                  this.deviceId.push(deviceId);
                  this.$refs.devices[index].scrollIntoView();
                  return response;
                })
              break
            case 401 :
              Vue.set(this.confirm.msg, 'msg', response.data)
              break
          }
          return response
        })
      },
      locateGateway: async function () {
        let currentArrIds = this.currentArrIds()

        if (currentArrIds.length !== 1) {
          alert('Please select one device')
          return
        }

        let deviceId = await currentArrIds[0]

        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/devices/${deviceId}`,
          path_template: '/api/devices/{id}'
        }).then(response => {
          switch (response.status) {
            case 200 :
              let device = response.data.data
              this.buildingId = device.building_id
              this.getGateways()
                .then(response => {
                  let index = this.$refs.devices.findIndex(el => el.getAttribute('data-id') === device.id.toString());
                  this.deviceId.push(deviceId);
                  this.$refs.devices[index].scrollIntoView();
                  return response;
                })
              break
            case 401 :
              Vue.set(this.confirm.msg, 'msg', response.data)
              break
          }
          return response
        })
      },
      fetchAllDevices: function () {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: 'api/devices?building_id=' + this.buildingId,
          path_template: '/api/devices'
        }).then(response => {
          switch (response.status) {
            case 200:
              for(let i = 0; i < response.data.data.length; i++ ) {
                let device = response.data.data[i];
                response.data.data[i].device_model = this.deviceModels[device.device_model_id];
                response.data.data[i].firmware_no_int = device.firmware_no ? parseInt(device.firmware_no.substr(2), 16) : undefined;
                response.data.data[i].level = [device.sub_building_name, device.level].filter(el=>el).join(' - ');
              }
              this.devices = response.data.data;
              break
          }
        })
      },
      sort: function (s) {
        if (s === this.currentSort.field) {
          this.currentSort.sort = this.currentSort.sort === 'asc' ? 'desc' : 'asc';
        }
        this.currentSort.field = s;
      },
      confirmPopup: async function (action) {
        let currentArrIds = this.currentArrIds(),
          resultIds = [],
          title = this.currentPage == 'devices' ? action + ' may have massive performance impact!' : 'The building EMIoT system maybe unavailable for up to 24 hours. Are you sure want to proceed?';

        for (let i in currentArrIds) {
          resultIds.push(await currentArrIds[0])
        }

        this.confirm = {
          action: action,
          title: 'Are you sure to execute: ' + action,
          msg: title,
        };
        this.dataToPassToDashBoardModal.commandToSend = action;
        this.dataToPassToDashBoardModal.method = 'POST';
        this.dataToPassToDashBoardModal.deviceIds = resultIds;
        this.dataToPassToDashBoardModal.showModal = true;
        this.dataToPassToDashBoardModal.router = 'api/devices-commands';
        this.dataToPassToDashBoardModal.pathTemplate = '/api/devices-commands/{device_id}';
      },
      confirmDelete: async function (action) {
        let currentArrIds = this.currentArrIds(), deviceId

        if (currentArrIds.length !== 1) {
          alert('Please select one device')
          return
        }

        deviceId = await currentArrIds[0]
        let index = this.devices.findIndex(device => device.id == deviceId)

        this.confirm = {
          action: action,
          title: 'Are you sure to execute: ' + action,
          msg: action + ' will delete this User',
        }
        this.dataToPassToModal.id = deviceId[0]
        this.dataToPassToModal.index = index
        this.dataToPassToModal.router = 'api/devices/'
        this.dataToPassToModal.showModal = true
        this.dataToPassToModal.pathTemplate = '/api/devices/{id}'
        this.unSelect()
      },
      retrieveLog: async function (command) {
        const currentArrIds = await this.currentArrIds();
        this.dataToPassToDeviceLogModal.showModal = false;
        if (currentArrIds.length !== 1) {
          alert('One support one device to retrieve logs');
          return;
        }

        const deviceId = await currentArrIds[0];
        const deviceIp = await this.resolveIp(deviceId);

        this.dataToPassToDeviceLogModal.deviceId = deviceId;
        this.dataToPassToDeviceLogModal.deviceIp = deviceIp;
        this.dataToPassToDeviceLogModal.command = command;
        this.dataToPassToDeviceLogModal.showModal = true;
      },
      sendCommand: async function (command) {
        let currentArrIds = this.currentArrIds()
        this.dataToPassToDashBoardModal.showModal = false
        if (currentArrIds.length == 0) {
          alert('Please select some devices before sending any command')
          return
        }

        let promises = []
        for (let index in currentArrIds) {
          let deviceId = await currentArrIds[index]
          promises.push({
            result:
              this.$store.dispatch(
                'apiResult',
                {
                  method: 'POST',
                  path: `api/devices-commands/${deviceId}`,
                  data: {command: command},
                  path_template: '/api/devices-commands/{device_id}'
                }
              ),
            deviceId: deviceId,
            command: command
          })
        }

        return this.displayResults(promises).then(results => {
          switch(this.currentPage) {
            case 'devices':
              this.fetchAllDevices();
              break;
            case 'gateways':
              this.getGateways();
              break;
          }

          return results;
        });
      },

      sendTechnicianAccessibleCommands: async function (command) {
        let currentArrIds = this.currentArrIds()
        this.dataToPassToDashBoardModal.showModal = false
        if (currentArrIds.length == 0) {
          alert('Please select some devices before sending any command')
          return
        }

        let promises = []
        for (let index in currentArrIds) {
          let deviceId = await currentArrIds[index]
          promises.push({
            result:
              this.$store.dispatch(
                'apiResult',
                {
                  method: 'POST',
                  path: `api/devices-commands/${deviceId}/technician-accessible-commands`,
                  data: {command: command},
                  path_template: '/api/devices-commands/{device_id}/technician-accessible-commands'
                }
              ),
            deviceId: deviceId,
            command: command
          })
        }
        this.displayResults(promises)
      },

      unSelect: function () {
        this.deviceId = []
        this.currentIds = ''
        this.promises = []
        this.dataToPassToDeviceStatusModal.modalData = []
      },
      displayResults (promises) {
        let that = this;
        this.dataToPassToDeviceStatusModal.modalData = [];
        return axios.all(promises).then((results) => {
          results.forEach(promise => {
            return promise.result.then(response => {
              let data = {}
              switch (response.status) {
                case 200 :
                  data = {
                    deviceId: promise.deviceId, message: 'Success',
                    command: promise.command
                  }
                  break
                case 422:
                case 400:
                case 500:
                  data = {
                    deviceId: promise.deviceId, message: 'Failed',
                    command: promise.command
                  }
                  break
              }
              if (data.deviceId !== undefined) {
                if (!this.noPopup.length) {
                  that.dataToPassToDeviceStatusModal.modalData.push(data)
                  this.dataToPassToDeviceStatusModal.showModal = true
                } else {

                }
              }
            });
          });
          return results;
        });
      },
      manualCommand: function () {
        if (this.deviceId.length > 1 || this.deviceId.length == 0) {
          alert('Please select one device')
          return
        }
        this.$store.dispatch('apiResult', {
          method: 'get',
          path: `api/devices/${this.deviceId}`,
          path_template: '/api/devices/{id}'
        }).then(response => {
          this.dataToPassToManualCommandModal.deviceId = response.data.data.id
          this.dataToPassToManualCommandModal.ip_address = response.data.data.ip_addr
          this.dataToPassToManualCommandModal.showModal = true
        })
      }
    },

    computed: {
      buildingTools: function() {
        return new Building;
      },
      tools: function() {
        return new Tools;
      },
      deviceModelTools: function () {
        return new DeviceModel;
      },
      currentBuilding: function () {
        return this.sortedBuildings.find(el => el.id === this.buildingId);
      },
      buildingFilted: function () {
        return this.sortedBuildings.filter((el) => {
          let searchText = this.clientBuilding.searchText
              .replace(/\W/g, ' ')
              .replace(/\s+/g, ' ')
              .toLowerCase()
              .split(' ')
              .filter(txt => txt !== ''),
            context = (el.fullAddress + ' ' + el.strata_no + ' ' + el.name).toLowerCase();
          if(this.clientBuilding.searchText.length) {
            for(let i = 0; i < searchText.length; i++) {
              if(context.indexOf(searchText[i]) === -1){
                return false;
              }
            }
          }
          return true;
        });
      },
      pagedBuilding: function() {
        let start = (this.clientBuilding.currentPage - 1) * this.clientBuilding.perPage,
          end = start + this.clientBuilding.perPage;

        this.clientBuilding.totalPage = parseInt(Math.ceil(this.buildingFilted.length / this.clientBuilding.perPage));

        return this.buildingFilted.slice(start, end);
      },
      sortedBuildings: function () {
        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
        return this.buildings
          .map(building => {
            building.fullAddress = [
              building.state,
              building.suburb,
              building.post_code,
              building.address
            ].filter(Boolean).join(', ');
            return building;
          })
          .sort((a, b) => {
            return collator.compare(a.fullAddress, b.fullAddress);
          });
      },
      sortedDevices: function () {
        let fieldsInChain = this.tools.chainFields(this.currentSort.field),
          devices = this.tools.noRefData(this.devices),
          reload = this.reload;

        return this.initLoaded ? this.tools.sort(
          devices,
          fieldsInChain,
          this.currentSort.sort !== 'desc',
          true,
          {numeric: true, sensitivity: 'base'},
          {
            '*': (a, b) => {
              let aData = this.tools.findValue(a, fieldsInChain),
                bData = this.tools.findValue(b, fieldsInChain);
              aData = this.tools.convertEmpty(aData);
              bData = this.tools.convertEmpty(bData);
              return {
                aData: aData === undefined || aData === bData ? -1 * a['last_comm'] : aData,
                bData: bData === undefined || aData === bData ? -1 * b['last_comm'] : bData
              }
            }
          }
        ): [];
      },
    }
  }
</script>
